// Snapshot rows only — never gate off a content row's own status.
export const DELIVERED_STATUS_ID = 150

export const isCurrentVersionDelivered = (content) => {
  if (!content?.histories?.length || !content.version) return false
  return content.histories.some(
    (history) => history.serviceJobHistoryId
      && history.version === content.version
      && history.serviceJobStatusId >= DELIVERED_STATUS_ID,
  )
}
